import React, { useRef, useEffect } from 'react';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Doughnut } from 'react-chartjs-2';
import { WrapperDoughnut } from './Chart.styles';
import { theme } from '../../../Theme';
ChartJS.register(ArcElement, Tooltip, Legend);

interface ChartProps {
  loanDepot?: number;
  otherDebts?: number;
  potentialSavings?: number;
  lender?: string;
}

export const Chart: React.FC<ChartProps> = ({ loanDepot = 0, otherDebts = 0, potentialSavings = 0, lender = '' }) => {
  const chartRef = useRef<ChartJS<'doughnut'> | null>(null);
  const data = {
    labels: [],
    datasets: [
      // TO-DO Improve the lender usage
      {
        labels: 'Data',
        data: [loanDepot, otherDebts, potentialSavings],
        backgroundColor: [
          lender.toLowerCase().includes('loandepot') ? theme.colors.primary : theme.colors.primaryColor,
          lender.toLowerCase().includes('loandepot') ? theme.colors.bgLightLilac : theme.colors.bgLightGray,
          theme.colors.progressBarThirdColor,
        ],
      },
    ],
  };
  useEffect(() => {
    const chartInstance = chartRef.current;

    return () => {
      if (chartInstance) {
        chartInstance.destroy();
      }
    };
  }, []);

  return (
    <WrapperDoughnut>
      <Doughnut ref={chartRef} data={data} options={{ cutout: '50%' }} />
    </WrapperDoughnut>
  );
};
